export const GET_COURSE_STATS_REQUEST = 'COURSE_STATS.GET_COURSE_STATS_REQUEST';
export const GET_COURSE_STATS_SUCCESS = 'COURSE_STATS.GET_COURSE_STATS_SUCCESS';
export const GET_COURSE_STATS_ERROR = 'COURSE_STATS.GET_COURSE_STATS_ERROR';
export const CLEAR_COURSE_STATS = 'COURSE_STATS.CLEAR_COURSE_STATS';
